/*eslint-env node */

exports.selectProductVariant = ({ variantId, products, noneSelected }) => {
  let alreadySelected = false

  products.forEach((product, i) => {
    product.variants.forEach((variant, j) => {
      let quantity = 0

      if (!variantId) {
        // if first load, we select the first variant of the first product
        if (noneSelected) {
          quantity = 0
        } else {
          if (variant.availableForSale && !alreadySelected) {
            quantity = 1
            alreadySelected = true
          } else {
            quantity = 0
          }
        }
      } else if (variantId === variant.id) {
        quantity = variant.id === variantId ? 1 : 0
      }

      products[i].variants[j].quantity = quantity
    })
  })

  return products
}
